
define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 通视分析观察模式。
     *
     * @exports EnumObservationMode
     * 
     * @see SightLineAnalysis#mode
     */
    var EnumObservationMode = {
        /**
         * 扩散，即单观察点多目标点形式。
         * @type {String}
         * @constant
         */
        DIVERGENT: "DIVERGENT",

        /**
         * 聚合，即多观察点单目标点形式。
         * @type {String}
         * @constant
         */
        CONVERGENT: "CONVERGENT"
    }
    freezeObject(EnumObservationMode)
    /**
     * 反向查找观察模式的类型。
     * 
     * @param {Number} value 观察模式的数值。
     * @returns {String} 观察模式的名称。
     */
    function getName(value) {
        for (var key in EnumObservationMode) {
            if (EnumObservationMode.hasOwnProperty(key) && EnumObservationMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        DIVERGENT: "DIVERGENT",
        CONVERGENT: "CONVERGENT",
        getName: getName
    }
})